import { render, staticRenderFns } from "./RenewedNumber.vue?vue&type=template&id=449cf672&"
import script from "./RenewedNumber.vue?vue&type=script&lang=js&"
export * from "./RenewedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports